// Used by StepBasics.jsx for the "Języki komunikacji" multi-select. Values are ISO 639-1 codes
// (plus "auto" for automatic detection) stored as-is in Campaign.Languages (List<string>, no backend
// validation -- see task-32 notes for why the value set is enforced only here, in the UI).
export const CAMPAIGN_LANGUAGE_OPTIONS = [
    { value: "pl", label: "Polski" },
    { value: "en", label: "Angielski" },
    { value: "de", label: "Niemiecki" },
    { value: "ru", label: "Rosyjski" },
    { value: "uk", label: "Ukraiński" },
    { value: "auto", label: "Wykrywaj automatycznie" },
];

export const CAMPAIGN_LANGUAGE_AUTO_VALUE = "auto";
